import React from "react";
import { useNavigate } from "react-router-dom";

function Successfully() {
  const navigate = useNavigate();
  return (
    <section className="py-8 md:py-12 lg:py-16 form-bg">
      <div className="container">
        <div className="bg-white p-[15px] md:p-[50px] rounded-[10px] max-w-[475px] shadow-[0px_2px_24px_rgba(0,0,0,0.05)] w-full mx-auto border border-zinc-100 w-full">
          <div className="text-center">
            <img src="/images/tik.svg" alt="tik" className="mx-auto" />
          </div>
          <h1 className="headings-h1 text-center text-zinc-950 mb-2 mt-3">
            Password reset link sent successfully.
          </h1>
          <p className="text-center text-zinc-500 body-lg">
            Check your mail for reset password link.
          </p>
          <button className="btn btn-pri mt-3 w-full" onClick={()=> navigate('../login')}>Back to login</button>
        </div>
      </div>
    </section>
  );
}

export default Successfully;
